export const SET_FORM_MODE = "SET_FORM_MODE";
export function action_updateFormMode(mode) {
	return { type: SET_FORM_MODE, payload: mode };
}

export const SET_FIRST_LOAD = "SET_FIRST_LOAD";
export function action_updateFirstLoad(isFirstLoad) {
	return { type: SET_FIRST_LOAD, payload: isFirstLoad };
}

export const SET_EDP_CONFIG = "SET_EDP_CONFIG";
export function action_updateEdPConfiguration(object, getted) {
	return { type: SET_EDP_CONFIG, payload: { object, getted } };
}

export const SET_EDP_CONFIG_ERROR_VALIDATIONS = "SET_EDP_CONFIG_ERROR_VALIDATIONS";
export function action_updateEdPConfigurationErrorValidations(l_validations) {
	return { type: SET_EDP_CONFIG_ERROR_VALIDATIONS, payload: l_validations };
}

export const SET_EDP_CONFIG_OBJECT_PROPERTY = "SET_EDP_CONFIG_OBJECT_PROPERTY";
export function action_updateEdpConfigObjectProperty(propertyName, propertyValue) {
	return { type: SET_EDP_CONFIG_OBJECT_PROPERTY, payload: {propertyName, propertyValue} };
}



export const ADD_EDP_CONFIG_PARTY_GROUP = "ADD_EDP_CONFIG_PARTY_GROUP";
export function action_addEdpConfigPartyGroup(group) {
	return { type: ADD_EDP_CONFIG_PARTY_GROUP, payload: group };
}
export const UPDATE_EDP_CONFIG_PARTY_GROUP = "UPDATE_EDP_CONFIG_PARTY_GROUP";
export function action_updateEdpConfigPartyGroup(itemId, group) {
	return { type: UPDATE_EDP_CONFIG_PARTY_GROUP, payload: {itemId, group} };
}
export const DELETE_EDP_CONFIG_PARTY_GROUP = "DELETE_EDP_CONFIG_PARTY_GROUP";
export function action_deleteEdpConfigPartyGroup(itemId) {
	return { type: DELETE_EDP_CONFIG_PARTY_GROUP, payload: itemId };
}


export const UPDATE_EDP_CONFIG_PARTY_GROUP_CONFIG = "UPDATE_EDP_CONFIG_PARTY_GROUP_CONFIG";
export function action_updateEdpConfigPartyGroupConfig(itemId, item) {
	return { type: UPDATE_EDP_CONFIG_PARTY_GROUP_CONFIG, payload: {itemId, item} };
}

export const UPDATE_EDP_CONFIG_DI = "UPDATE_EDP_CONFIG_DI";
export function action_updateEdpConfigDI(itemId, item, propertyNameId) {
	return { type: UPDATE_EDP_CONFIG_DI, payload: {itemId, item, propertyNameId} };
}

export const UPDATE_EDP_ONPREPARING = "UPDATE_EDP_ONPREPARING";
export function action_updateEdpOnPreparing(onpreparing) {
	return { type: UPDATE_EDP_ONPREPARING, payload: onpreparing };
}
